/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Wine',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            d="M16.398 2.002c.42 0 .793.26.91.663.665 2.285 2.284 9.717-4.662 10.146l.002 6.89a1 1 0 0 0 1 1h1.482a.65.65 0 0 1 .647.648.65.65 0 0 1-.647.648H8.869a.65.65 0 0 1-.647-.648.65.65 0 0 1 .647-.648h1.482a1 1 0 0 0 1-1v-6.872C4.409 12.382 6.027 4.95 6.693 2.665c.117-.403.49-.663.91-.663h8.795zM7.79 3.201c-.332 1.199-.777 3.355-.408 5.193.189.942.576 1.718 1.223 2.264s1.679.975 3.395.975 2.754-.433 3.396-.975c.647-.546 1.033-1.322 1.222-2.264.369-1.838-.076-3.994-.407-5.193H7.79z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
